export const ScreenType = {
	WARNING: 'warning',
	EMPTY_NO_DEPENDENCY: 'empty_no_dependency',
	EMPTY_TOO_MANY_FILTERS: 'empty_too_many_filters',
} as const;
export type ScreenType = (typeof ScreenType)[keyof typeof ScreenType];
export type Props = {
	type: ScreenType;
};
